import type { ChangeSpaceAction, Space } from '..';
import { CHANGE_SPACE } from '../actionTypes';

const changeSpace = (space: Space): ChangeSpaceAction => ({
	type: CHANGE_SPACE,
	payload: space,
});

export default changeSpace;
